import { jsx as _jsx } from "react/jsx-runtime";
import { DIRECTIONAL_ICONS, FILLED_ICONS, ICON_PATHS } from '@lubehub/theme';
/**
 * One glyph from the shared set (`@lubehub/theme` icons), drawn the way the
 * mobile app draws it: 24-unit grid, round caps and joins, `currentColor`.
 *
 * Decorative by default (`aria-hidden`). Directional glyphs — a chevron, an
 * arrow — carry a class that mirrors them under `[dir='rtl']`, so "forward"
 * points the way the reader is going without each screen deciding.
 */
export function Icon({ name, size, label, className }) {
    const directional = DIRECTIONAL_ICONS.includes(name);
    const filled = FILLED_ICONS.includes(name);
    const dimension = size === undefined ? '1.25em' : `${String(size)}px`;
    return (_jsx("svg", { className: ['lh-icon', directional && 'lh-icon--directional', className]
            .filter(Boolean)
            .join(' '), width: dimension, height: dimension, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.8, strokeLinecap: "round", strokeLinejoin: "round", focusable: "false", ...(label === undefined ? { 'aria-hidden': true } : { role: 'img', 'aria-label': label }), children: ICON_PATHS[name].map((d, index) => (_jsx("path", { d: d, fill: filled ? 'currentColor' : undefined, fillOpacity: filled ? 0.18 : undefined }, `${name}-${String(index)}`))) }));
}
//# sourceMappingURL=Icon.js.map